/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-extend-native */

import { t } from "i18next";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import { EMPTY_GUID } from "utils/helpers";
import { createDiscussion } from "./reducer/MapActions";
import { setDiscussion, setOpenDiscussion } from "./reducer/commentSlice";
type Discussion = {
    objId: any;
    objName: any;
    cjmId: any;
    personaId: any;
    prefixRelationships?: string;
    onSuccess?: any;
};

declare global {
    interface Array<T> {
        addDiscussionAction({...props }: any): Array<T>;
    }
}


Array.prototype.addDiscussionAction = function (props: any) {

    const obj = {
        id: "comment",
        text: t("ADD_COMMENT"),
        icon: "comment",
        onClick: () => {
           const userInfo = jwtDecode<{ userId: string }>(Cookies.get('Authorization-cemantica') || '');
            createDiscussion({
                ...props,ownerId:userInfo?.userId || EMPTY_GUID , onSuccess: (res: any) => {
                    if (props.onSuccess) {
                        props.onSuccess();
                    }
                    setDiscussion(res)
                    setOpenDiscussion(res.id)
                }
            });
        },
    }
    this.push(obj)
    return this;
}

Array.prototype.sortByModifiedOn = function () {
    return this?.sort((a, b) => {
        const dateCommentA = a.comments[0]?.lastModifiedOn || a.lastModifiedOn;
        const dateCommentB = b.comments[0]?.lastModifiedOn || b.lastModifiedOn;

        const dateA = new Date(dateCommentA);
        const dateB = new Date(dateCommentB);
        return dateB - dateA; // Sort in descending order
      }) || [];
}

export function getAllMapsParams(search: string) {
	const params = new URLSearchParams(search.toLowerCase());
	const cjmIdStr = params.get("cjmid");
	const personaIdStr = params.get("personaid");
    const hideForPdf = params.get("isprint") === '1'
	return { cjmIdStr, personaIdStr ,hideForPdf};
}